import { render } from "./Forgot_password.vue?vue&type=template&id=4eb1fba4&scoped=true"
import script from "./Forgot_password.vue?vue&type=script&lang=js"
export * from "./Forgot_password.vue?vue&type=script&lang=js"

import "./Forgot_password.vue?vue&type=style&index=0&id=4eb1fba4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb1fba4"]])

export default __exports__